import { createFileRoute } from '@tanstack/react-router'
import { MedicalReferences } from '@/features/medical-references'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/medical-references/')({
  beforeLoad: requireAdmin,
  component: MedicalReferencesPage,
})

function MedicalReferencesPage() {
  return <MedicalReferences />
}
